"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneResponseToJSON = exports.MilestoneResponseFromJSONTyped = exports.MilestoneResponseFromJSON = void 0;
var _1 = require("./");
function MilestoneResponseFromJSON(json) {
    return MilestoneResponseFromJSONTyped(json, false);
}
exports.MilestoneResponseFromJSON = MilestoneResponseFromJSON;
function MilestoneResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': json['target'],
        'rewardConfig': (0, _1.RewardConfigResponseFromJSON)(json['rewardConfig']),
        'name': json['name'],
    };
}
exports.MilestoneResponseFromJSONTyped = MilestoneResponseFromJSONTyped;
function MilestoneResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': value.target,
        'rewardConfig': (0, _1.RewardConfigResponseToJSON)(value.rewardConfig),
        'name': value.name,
    };
}
exports.MilestoneResponseToJSON = MilestoneResponseToJSON;
